/**
 * FIREFOX COMPATIBILITY FIX
 * Patch existing LazyImage to handle Firefox loading issues.
 *
 * Root cause: The custom-elements polyfill fires connectedCallback (and thus
 * handleLazy) synchronously during vendor.js execution. In Firefox, an eager-
 * loaded image may have its `load` event fire *before* the listener is attached,
 * leaving the `.media.loading` class stuck on the <picture> element and the CSS
 * rule `[data-lazy-image] .media.loading > img { opacity: 0 }` permanently
 * hiding the image. Firefox's bfcache also restores this broken state on back-
 * navigation.
 *
 * Primary fix: sections/slideshow-hero.liquid pre-adds class="loaded" to the
 * first (eager) slide's <img> so handleLazy skips the loading state entirely.
 *
 * Secondary fix (safety net): patch is applied synchronously here so future
 * handleLazy calls are also correct, plus a retroactive scan removes any
 * `.media.loading` whose image is already complete.
 */

(function () {
    if (typeof LazyImage === 'undefined') return;

    var originalHandleLazy = LazyImage.prototype.handleLazy;

    LazyImage.prototype.handleLazy = function () {
        if (this.classList.contains('loaded')) return;

        // Image already downloaded — finalise immediately, skip loading state
        if (this.complete && this.naturalHeight !== 0) {
            this.classList.add('loaded');
            if (this.media) this.media.classList.remove('loading');
            return;
        }

        // Call original for images that still need to load
        originalHandleLazy.call(this);

        // Fallback: if complete state settles asynchronously (Firefox timing)
        if (!this.complete && this.media) {
            var img = this;
            var media = this.media;
            var check = function () {
                if (img.complete && img.naturalHeight !== 0 && !img.classList.contains('loaded')) {
                    img.classList.add('loaded');
                    media.classList.remove('loading');
                }
            };
            setTimeout(check, 0);
            setTimeout(check, 100);
        }
    };

    // Retroactively fix images already stuck in the loading state.
    // The polyfill called handleLazy with the original method before this patch
    // was applied, so any image that was complete-but-not-flagged is stuck.
    function fixStuckImages() {
        document.querySelectorAll('.media.loading').forEach(function (media) {
            var img = media.querySelector('img');
            if (img && img.complete && img.naturalHeight !== 0 && !img.classList.contains('loaded')) {
                img.classList.add('loaded');
                media.classList.remove('loading');
            }
        });
    }

    // Run now and after browser repaints to catch any timing edge-cases
    fixStuckImages();
    requestAnimationFrame(function () {
        fixStuckImages();
        requestAnimationFrame(fixStuckImages);
    });

    // Firefox bfcache: when the user navigates back, the page is restored from
    // memory with `.media.loading` still set. Fix it on pageshow.
    window.addEventListener('pageshow', function (event) {
        if (event.persisted) {
            fixStuckImages();
            requestAnimationFrame(fixStuckImages);
        }
    });
}());